module.exports = __webpack_public_path__ + "static/media/payment.29c318e4.png";